import { createNS } from "@ontologies/core";

const wde = createNS("http://www.wikidata.org/entity/");

export default {
  ns: wde,
};
